import { FeeScopeEnum } from 'models/PropertyFees';
import { useTranslation } from 'react-i18next';

const ScopeCell = ({ getValue }: { getValue: () => FeeScopeEnum | null }) => {
  const { t } = useTranslation();
  const value = getValue();
  const text = value
    ? t(
        `pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.scopes.${value}`,
      )
    : t(
        'pageProperty.feesTaxesAndPolicies.propertyFeesAndTaxes.scopes.PER_STAY',
      );

  return <span>{text}</span>;
};

export default ScopeCell;
